/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { LOCAL_STORAGE } from "utils/constants";
import { isFromLLMReferrer } from "utils/utils";

const RefHandler = () => {
    const [refSource, setRefSource] = useState('unset');
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const setRefParam = () => {
        // Priorities : gads, localstorage, refURL
        const gclidParam = searchParams?.get('gclid');
        const fbclidParam = searchParams?.get('fbclid');
        const gadParam =
            searchParams?.get('gad_source') || gclidParam ? 'gads' : null;
        const fbParam = fbclidParam ? 'fbads' : null;
        const storageRef = localStorage.getItem(LOCAL_STORAGE.REF);
        const refParamUrl = searchParams.get('ref');

        const getUTMSourceFromQuery = () => {
            const utmSourceParam = searchParams?.get('utm_source');
            if (!utmSourceParam) {
                return null;
            }
            const utmSource = Array.isArray(utmSourceParam)
                ? utmSourceParam[0]
                : utmSourceParam;
            return utmSource && utmSource.length > 0 ? utmSource : null;
        };

        const getLLMReferrerLabel = () => {
            if (typeof document === 'undefined' || !document.referrer) {
                return null;
            }
            if (!isFromLLMReferrer()) {
                return null;
            }
            try {
                const { hostname } = new URL(document.referrer);
                return hostname || null;
            } catch (error) {
                return document?.referrer || 'llm';
            }
        };

        const appendRefMetadata = (refValue) => {
            const additions = [];
            const utmSource = getUTMSourceFromQuery();
            const llmReferrer = getLLMReferrerLabel();

            if (utmSource) {
                additions.push(utmSource);
            }
            if (llmReferrer) {
                additions.push(llmReferrer);
            }

            if (!additions.length) {
                return refValue;
            }

            return `${refValue}_${additions.join('_')}`;
        };

        const setAndStoreRef = (refValue) => {
            const finalRef = appendRefMetadata(refValue);
            setRefSource(finalRef);
            localStorage.setItem(LOCAL_STORAGE.REF, finalRef);
        };

        if (gadParam && gadParam.length > 0) {
            // If Gads param, then it overrides everything
            setAndStoreRef(gadParam);
        } else if (fbParam && fbParam.length > 0) {
            setAndStoreRef(fbParam);
        } else if (storageRef && storageRef.length > 0 && storageRef !== 'unknown') {
            // else if a param is already stored in the local storage, that's the preffered one
            // No need to store it in localstorage since it's already there
            setAndStoreRef(storageRef);
        } else if (refParamUrl && refParamUrl.length > 0) {
            // If no param are stored in localstorage yet, the ref in current URL is the preferred
            setAndStoreRef(refParamUrl);
        } else {
            // else fallback on creating a landing_X param
            let refParamFallback = 'unknown';
            setAndStoreRef(refParamFallback);
        }
    };

    const storeQueryStringIfNeeded = () => {
        if (typeof window === 'undefined') {
            return;
        }
        const search = window.location.search || '';
        if (!search || search.length === 0) {
            return;
        }
        const hasGadsRef = /[?&]ref=([^&]*gads[^&]*)/i.test(search);
        if (!hasGadsRef) {
            return;
        }
        try {
            localStorage.setItem(LOCAL_STORAGE.LANDING_QUERY_STRING, search);
        } catch (error) {
            // Ignore storage errors (private browsing, etc.)
        }
    };
    useEffect(() => {
        const gclidParam = searchParams?.get('gclid');
        if (gclidParam && gclidParam.length > 0) {
            localStorage.setItem("gclid", gclidParam);
        }
        const fbclidParam = searchParams?.get('fbclid');
        if (fbclidParam && fbclidParam.length > 0) {
            localStorage.setItem("fbclid", fbclidParam);
        }
        const gacidParams = searchParams?.get('gacid');
        if (gacidParams && gacidParams.length > 0) {
            localStorage.setItem("gacid", gacidParams);
        }
        if (refSource === 'unset') {
            setRefParam();
        }
        storeQueryStringIfNeeded();
    }, [location]);

    return <></>;
};

export default RefHandler;